export type Backbone = {
  Events: BackboneEvents;
  Router: BackboneRouter;
  trigger: Function;
};

// TODO: needs to be cleaned up as backboneListner should of type BackboneEvents
export type BackboneListener = {
  listenTo: Function;
};

export type BackboneRouter = {
  navigate: Function;
};

export type BackboneEvents = {
  listenTo: Function;
  stopListening: Function;
  trigger: Function;
};

export type BackboneModel = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [index: string]: any;
  new(property?: string);
  get: Function;
  set: Function;
  trigger: Function;
  toJSON: Function;
  unset: Function;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  attributes: Record<string, any>;
};

export type BackboneCollection = {
  new(property?: string);
  at: Function;
  filter: Function;
  get: Function;
  indexOf: Function;
  set: Function;
  trigger: Function;
  models: BackboneModel[];
  toJSON: Function;
};

export type I18n = {
  getText: Function;
};

export type Gtm = {
  pushToDataLayer: Function;
  pushVersionedEvent: Function;
  pushEvent: Function;
  pushCustomEvent: Function;
  setVirtualPage: Function;
  pushSocialMediaEvent: Function;
  pushLinkEvent: Function;
};

export type Liquid = {
  supportUrl: string;
  meta: { seoPageTitle: string; collectionGenerationType: string };
  divIdIpadDFP: string;
  divIdMobileDFP: string;
  newArrivalsLink: string;
  divIdDesktopDFP: string;
  /* eslint-disable camelcase */
  DFP_LoggedIn_HomePage_IPad: boolean;
  DFP_LoggedIn_HomePage_Mobile: boolean;
  DFP_Enabled: boolean;
  DFP_LoggedIn_HomePage_Desktop: boolean;
  faqUrl: string;
  persistentLoginCookie: string;
  validateShippingAddressNameSpace: string;
  apiAuthCookie: string;
  recaptchaSiteKey: string;
  joinPageUrl: string;
  hideSocialShareRAF: boolean;
  referralThanksUrl: string;
  page: {
    id: string;
    title: string;
    handle: string;
  };
  settings: {
    showReviews: boolean;
    enable_rn_feedback_popup_rn: boolean;
    // eslint-disable-next-line camelcase
    enable_shipment_tracking_flow: boolean;
    enable_RN_feedback_review: boolean;
    hiw_1_card_icon_image: boolean;
    hiw_2_card_icon_image: boolean;
    hiw_3_card_icon_image: boolean;
    hiw_tagline_cta_text: string;
    hiw_tagline_text: string;
    modifyOrClass: string;
    hiw_heading_only_over_image: boolean;
    hiw_steps_text_5_desc: string;
    hiw_steps_text_4_desc: string;
    hiw_steps_text_3_desc: string;
    hiw_steps_text_2_desc: string;
    hiw_steps_text_1_desc: string;
    hiw_steps_text_5_head: string;
    hiw_steps_text_4_head: string;
    hiw_steps_text_2_head: string;
    hiw_steps_text_3_head: string;
    hiw_steps_text_1_head: string;
    homepage__how_it_works__images: string;
    homepage__how_it_works__header: string;
    homepage__how_it_works__1__text: string;
    homepage__how_it_works__1__title: string;
    homepage__how_it_works__2__title: string;
    homepage__how_it_works__2__text: string;
    homepage__how_it_works__3__title: string;
    homepage__how_it_works__3__text: string;
    is_nonsj: any;
    entice_box_title_img: boolean;
    show_promotion_header: boolean;
    is_insider_tips_enabled: boolean;
    faq_url: string;
    powered_by_hub_page_url: string;
    enable_powered_by_site: boolean;
    powered_by_hub_site_footer_anchor_text: string;
    powered_by_hub_site_footer_positioning_text: string;
    powered_by_hub_site_footer_logo_image: string;
    powered_by_host_name: string;
    powered_by_hub_site_footer_logo_image_width: string;
    react_page: Array<string>;
    footer_talk_to_us_text: string;
    footer_service_name: string;
    enable_one_trust_script: boolean;
    enable_smartbanner_android: boolean;
    footer_links_opened_in_new_tab: string;
    enable_smartbanner_ios: boolean;
    redeem_gift_enabled: boolean;
    footer_intro_heading: string;
    footer_intro_text: string;
    footer_contact_us: string;
    footer_talk_to_us: string;
    footer_email_us: string;
    showSMSService: boolean;
    giveAwayAmountOff: string;
    giveAwayWinnersCount: string;
    giveAwayName: string;
    giveAwayMonthsOff: string;
    giveAwayDescription: string;
    giveAwaySubHeading: string;
    giveAwayHeading: string;
    giveAwayRulesEndDate: string;
    enable_dual_size_filter: boolean;
    enable_caf_flow: boolean;
    enable_afa_flow: boolean;
    terms_of_service_copyright_mail_address: any;
    client_legal_name: any;
    showRulesEndDate: string;
    dart_link: string;
    showDartAvailableSlotsAlpha: boolean;
    enable_dart: boolean;
    enable_free_dart: boolean;
    giveAwayResultDate: string;
    wufooFormId: string;
    giveAwayId: string;
    giveAwayEnabled: string;
    giveAwayEndDate: string;
    giveAwayStartDate: string;
    /* eslint-disable camelcase */
    allow_partial_slots_in_dart: boolean;
    curated_closet_Browse_Heading: string;
    curated_closet_Browse_Description: string;
    curated_closet_Browse_Button_Text: string;
    curated_closet_free_trial_heading: string;
    curated_closet_free_trial_description: string;
    curated_closet_free_trial_button_text: string;
    curated_closet_free_trial_after_nth_row_mobile: string;
    curated_closet_free_trial_after_nth_row_desktop: string;
    is_SB_enabled: boolean;
    homepage_logged_in__welcome_box__be_sure_to_fulfill_your_closet_minimum: string;
    homepage_logged_in__welcome_box__click_add_to_closet_on_your_desired_items: string;
    homepage_logged_in__welcome_box__build_your_closet: string;
    homepage_logged_in__explore_styles_button: string;
    homepage_logged_in__explore_styles_button__classes: string;
    homepage_logged_out__benefits_list: string;
    homepage__logged_out__benefits_list__title: string;
    homepage_logged_in__user_slogan_sub: string;
    homepage_logged_in__user_slogan: string;
    use_recaptcha_enterprise: boolean;
    payment_service: string;
    give_a_gift_enable_terms_and_conditions_accept_checkbox: boolean;
    subscription_confirmation_screen_disclaimer_wallet: string;
    subscription_confirmation_screen_disclaimer: string;
    enable_cc_page_additional_description: boolean;
    disclaimer_position: string;
    free_trial_subscription_confirmation_screen_disclaimer: string;
    paid_trial_subscription_confirmation_screen_disclaimer: string;
    free_trial_subscription_confirmation_screen_disclaimer_second: string;
    show_checkbox_with_disclaimer: boolean;
    subscription_confirmation_screen_disclaimer_second_wallet: string;
    subscription_confirmation_screen_disclaimer_second: string;
    free_trial_subscription_confirmation_cta_text: string;
    subscription_confirmation_screen_cta_text: string;
    subscription_confirmation_screen_title: string;
    enable_single_checkbox_billing_address: boolean;
    vat_inclusive_pricing_uk: boolean;
    subsciption_show_combined_payment_confirmation: boolean;
    replace_free_trial_text_by_complimentary_text: boolean;
    firstname_placeholder: string;
    show_promo_code_field: boolean;
    lastname_placeholder: string;
    address1_placeholder: string;
    address2_placeholder: string;
    city_placeholder: string;
    state_placeholder: string;
    zipcode_placeholder: string;
    phone_placeholder: string;
    enable_postcoder_places_api: boolean;
    enable_single_field_shipping_flow: boolean;
    showNewSubscriberOnboardingExperience: boolean;
    raf_heading_customer_name_enable: boolean;
    pause_price_plan_version_map: string;
    enable_share_via_email: boolean;
    raf_get_credits_from_api: boolean;
    domain_name: any;
    company_name: string;
    enable_recaptcha: any;
    collection_qc_correction: string;
    isCuratedCollectionActive: string;
    logo_position: string;
    login_service_mode: string;
    mobile_collection_qc_correction_needed: boolean;
    shopUrl: string;
    give_a_gift_enabled: boolean;
    enable_dot_sizing: boolean;
    enable_refer_a_friend: boolean;
    enable_seasonal_refresh_helper_script: boolean;
    enable_size_quiz: boolean;
    hideRAFLinkOnHeader: boolean;
    homepage_logged_out__modal__get_started_button: string;
    homepage_logged_out__modal__heading_html: string;
    homepage_logged_out__modal__subheading_html: string;
    homepage_logged_out__modal__sub_subheading_html: string;
    homepage_logged_out__modal__have_an_account_html: string;
    homepage_logged_out__modal__log_in_link_text: string;
    enable_enhanced_free_trial_ui: boolean;
    free_trial_home_sub_heading: string;
    free_trial_home_cta_text: string;
    nav_links_opened_in_new_tab: string;
    product_size_advisor: boolean;
    specify_nag_limit_in_session_or_lifetime: string;
    time_interval_in_which_nag_display_only_once_in_sec: string;
    inactivity_time_iterval_before_display_nag_in_sec: string;
    product_display_DFP_nag: boolean;
    collection_display_nag: boolean;
    product_brandNameNonClickableOnProductPage: boolean;
    product_show_brand: boolean;
    product_show_zoom: boolean;
    product_size_departments: any;
    product_buttons_shape: string;
    product_show_share_buttons: boolean;
    product_rating_type: string;
    product_show_bar_under_product_title?: boolean;
    product_show_bar_under_product_navigation_for_desktop?: boolean;
    product_collapsible_section_size_chart_title: string;
    product_collapsible_section_size_advisor_title: string;
    product_collapsible_section_product_details_title: string;
    product_collapsible_section_show_up_down_icons: boolean;
    product_collapsible_sections_sequence: string;
    product_show_product_title_below_image_mobile: boolean;
    product_show_more_collection_links_below_collapsible: boolean;
    sizes_page_headers_replace_rule: any;
    sizes_page_show_brand_size_type_subheader: any;
    sizes_page_show_brandlist: any;
    sizes_page_show_brandname: any;
    sizes_page_show_brand_size_type: any;
    size_quiz_cta_text_b: string;
    sizes_page_show_link_to_top: any;
    pagination_limit: any;
    curated_collection_page_size: string;
    curated_closet_page_size: string;
    service_name: any;
    collection_brand_select: any;
    collection_preview_brand: any;
    show_consistent_image_through_css: any;
    collection_buttons_shape: any;
    collection_qc: boolean;
    collection_last_weeks_list: string;
    sort_sizes_on_size_advisor: boolean;
    product_size_advisor_cta: string;
    product_show_whant_to_know_body_type_link: boolean;
    account_can_change_plan: boolean;
    days_left_before_next_payment: number;
    default_pause_plan_price: number;
    enable_downgrade_screen: boolean;
    enable_pause_screen: boolean;
    redirect_ppd_user: string;
    wufoo_url_fields: string;
    cancellation_survey_form_url: string;
    enableGooglePay: boolean;
    enableApplePay: boolean;
    terms_of_service_link: string;
    privacy_policy_link: string;
    page_not_found_url: string;
    online_cancellation_uk_date_format: string;
    showReviewSection?: boolean;
    enable_new_disclaimers?: boolean;
    tenant_creation_date_tos: string;
    terms_of_service_heading: string;
    terms_of_service_faq_url: string;
    tenant_creation_date: string;
    contact_email: string;
    contact_phone: string;
    contact_phone_alternative_form: string;
    contact_phone_number_form: string;
    PrivacyPolicyPageData: string;
    terms_of_service_copyright_phone_number: string;
    terms_of_service_copyright_mail: string;
    terms_of_service_copyright_address: string;
    terms_of_service_copyright_dispute_address: string;
    terms_of_service_copyright_tel_href: string;
    terms_of_service_site_url: string;
    plan_size: number;
    is_tos_content_published_via_script: boolean;
    quick_view_modal_show_brand: boolean;
    enable_ttb_popup_disclaimer: boolean;
    enable_closet_page_return_notify_banner: boolean;
    enable_resubscription_monte_cristo: boolean;
    show_get_started_button_on_index_page: boolean;
    show_get_started_button_on_hiw_page: boolean;
    hiw_page__how_it_works__images: string;
    hiw_page__how_it_works__header: string;
    hiw_page__how_it_works__1__title: string;
    hiw_page__how_it_works__1__text: string;
    hiw_page__how_it_works__2__title: string;
    hiw_page__how_it_works__2__text: string;
    hiw_page__how_it_works__3__title: string;
    hiw_page__how_it_works__3__text: string;
    default_free_trial_days_off: number;
    enable_ssr_seasonal_refresh_images: boolean;
    lohp_button_cta_paid_trial?: string;
    incentive_sub_heading_for_paid_trial?: string;
    replace_subheading_with_applied_discount_text?: boolean;
    enable_ai_filters_flow: boolean;
    homepage_logged_out__modal__text_under_cta?: string
    /* eslint-enable camelcase */
  };
  environment?: string;
  gbeeServiceLogoutUrl: string;
  siteName: string;
  blankMemberPhoto: string;
  cookieDomain: string;
  shopUrl: string;
  apiUrl: string;
  appUrl: string;
  namespaceID: string;
  recoverPwdPostUrl: string;
  template: string;
  SocialFBTrackingParms: string;
  SocialPinterestTrackingParms: string;
  minimizedVisitorNagDFPCountLimit: number;
  maximizedVisitorNagDFPCountLimit: number;
  maximizedSizeAdvisorNagDFPCountLimit: number;
  divIdEditorialContentDesktop: string;
  divIdEditorialContentMobile: string;
  divIdDFPNag: string;
  divIdGiftUserMobileDFPNag: string;
  divIdGiftUserDFPNag: string;
  divIdMobileClostMinNag: string;
  divIdMobileMinimizedNag: string;
  divIdClostMinNag: string;
  divIdSizeAdvisorDFPNagMobile: string;
  divIdSizeAdvisorDFPNagDesktop: string;
  divIdMobileActivationNag: string;
  divIdActivationNag: string;
  product: {
    handle: string;
  };
  divIdForTaxNotificationHomeMobile: string;
  divIdForTaxNotificationHomeDesktop: string;
  // eslint-disable-next-line camelcase
  closet_link: string;
  fsPagePool: number;
  divIdDFPOnTTBThankYouPage: string;
  metafieldContent: Array<string>;
};

export type Customer = {
  accountStatus: Function;
  closetingAllowed: string;
  externalUuid: string;
  custType: string;
  custSubType: Function;
  email: string;
  encryptedKey: string;
  encryptionVersion: string;
  firstName: string;
  getUserState: Function;
  isFreeTrial: Function;
  id: number;
  isCancelled: Function;
  isClosetAllowed: Function;
  isGuest: Function;
  isNotSubscriber: Function;
  isPaying: Function;
  isSubscriber: Function;
  isTrial: Function;
  lastName: string;
  name: string;
  paypalActiveCustomer: string;
  subType: string;
  tags: string[];
  trial: string;
  type: string;
  trialSubTypeGet: Function;
  uuid: string;
  isPPD: Function;
  isDelinquent: Function;
};

interface BvFeatureObject {
  type: string;
  brand: string;
  productId: number;
  bvProduct: string;
  categoryId: string;
  detail1: string;
  detail2: string;
  name?: string;
}

export interface BvConstructor {
  new(...args: any): BvFeatureObject;
}

export type BvAnalytics = {
  bvConversionEvent: Function;
  BvFeatureObject: BvConstructor;
  bvFeaturedUsedEvent: Function;
  bvPageViewEvent: Function;
  bvReviewInViewEvent: Function;
  bvTrackImpressionEvent: Function;
};

export type DateUtils = {
  addDaysToDate: Function;
  // eslint-disable-next-line max-len
  dayComparedToToday: (date: string, isUTCString: boolean) => { day: string; numberOfDaysDiff: number; formattedDate: string };
  addMonthsToDate: Function;
  convertISOInDDMMYYFormat: Function;
  convertToMDYformat: Function;
  convertUTCDateStringToEST: Function;
  differenceBetweenDates: Function;
  getDateInRequiredFormat: Function;
  getTimeString12HourFormat: Function;
  getDateString: Function;
  getDateStringFormatYrMnthDateHrsMinSec: Function;
  getDateYear: Function;
  getFormattedDate: Function;
  getISO8601DateString: Function;
  isDateToday: Function;
  isDateBetweenTwoDates: Function;
  parseISO8601DateString: Function;
  parseDate: Function;
  convertToMDYorDMYformat: Function;
  getUTCDateString: Function;
  convertUTCDateStringToLocale: Function;
};

type CollectionWithEditorialContent = {
  [key: string]: boolean;
};

type formatUtils = {
  formatMoney: Function;
  toOrdinal: Function;
  formatPhoneNumber: Function;
  convertStringToTextCapitalize: Function;
  addDecimalsToFloatPrice: Function;
  formatDate: Function;
  convertUTCDateStringToLocale: Function;
};

export type DomUtils = {
  getURLParameter: Function;
  sortFunction: Function;
  equalHeights: Function;
  updateDOMOnCancel: Function;
};

export type Emitter = {
  emit: Function;
  postEvent: Function;
  postSizeAdvisorEvent: Function;
  enhanceEvent: Function;
  register: Function;
  sendPageView: Function;
  sourceEventId: string;
};

export type NavigationUtils = {
  genericClickHandler: Function;
};

export type Utils = {
  getCommonUserStateFormat: Function;
  showAjaxErrorMessage: Function;
  eventForHomePageTTB: boolean;
  eventForClosetPageTTB: boolean;
  checkIfPartialSlotsAreAllowedInDart: () => boolean;
  numericToAlpha: (number: number) => string;
  getCollectionLinks: Function;
  autoTabForRequiredFields: (option: string) => void;
  errorHandlingForApiAuthentication: () => void;
  getHTMLElementBySelector: (selector: string) => JSX.Element;
  openModal: (selector: Element) => void;
  closeModal: (selector: Element) => void;
  protectedString: Function;
  getCCYearData: Function;
  getPlanSizeById: Function;
  getPlanNameById: Function;
  setMarketingPixelInfo: Function;
  getTrackingCodeCookieString: Function;
  checkDevice: Function;
  checkForDualSizeFilterVisibility: Function;
  defineDualSizeLengthKeyNameBasedOnProductType: Function;
  getFromStore: Function;
  removeFromStore: Function;
  removeURLParameter: Function;
  saveToStore: Function;
  setTrackingCode: Function;
  validateEmail: Function;
  getQuerystringParam: Function;
  initFoundation: Function;
  getClusterValue: Function;
  updateHeroBannerWithSource: Function;
  pluralize: Function;
  checkIfPaymentSourceWalletPay: Function;
  capitaliseString: Function;
  getParsedDataFromStore: Function;
  isPlainObject: Function;
  sortArrayByLocaleCompare: Function;
};

export type FbUtils = {
  shareLink: Function;
  initialiseFBSdk: Function;
};

export type TwitterUtils = {
  getTweetHref: Function;
};

export type SeasonalUtils = {
  handleSeasonalRefresh: Function;
};
export type UserObjectInit = {
  clearLoginState: Function;
}

export type UpsInstance = {
  determineFreeTrialViaPendingPromo: Function;
};

export type Gb = {
  removeCookie(arg0: string, arg1: string, cookieDomain: string): unknown;
  animate: {
    start: (selector?: string) => void;
    stop: (selector?: string) => void;
  };
  getCookie(arg0: string): unknown;
  recaptchaSiteKey: string;
  joinPageUrl: string;
  hideSocialShareRAF: boolean;
  referralThanksUrl: string;
  bvAnalytics: BvAnalytics;
  customer: Customer;
  CheckEuropeVisitor: {
    isUserLocationAllowed: Function;
  };
  formatUtils: formatUtils;
  dateUtils: DateUtils;
  domUtils: DomUtils;
  liquid: Liquid;
  LoginRouter: BackboneRouter;
  navigationUtils: NavigationUtils;
  places: Places;
  utils: Utils;
  upsObject: {
    getUPSInstance: Function;
  };
  DFP: {
    callDfp: Function;
  };
  fbUtils: FbUtils;
  twitterUtils: TwitterUtils;
  Province: ProvinceMixin;
  config: config;
};

export type ProvinceMixin = {
  getCodeByName: Function;
  PROVINCES: Array<{code: string; name: string}>;
  getStateByCode: Function;
}

export type Places = {
  callAutoComplete: Function;
}

export type LocaleInfo = {
  countryCode: string;
  currencyCode: string;
  currencyName: string;
  currencyShortName: string;
  currencySymbol: string;
  dateDisplayFormat: string;
  timezoneCode: string;
  timezoneName: string;
}

interface CustomError {
  push: (error: Error) => void;
  meta: Record<string, any>;
}

export type WindowCaastle = {
  closetingAllowed: string;
  closetLink: string;
  customerType: string;
  desktopLinklist1: string;
  guestClosetLink: string;
  isSubscriber: boolean;
  $: Function;
  linklists: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    links: Array<Record<string, any>>;
  };
  mobileLinklist1: string;
  search: {
    performed: string;
    terms: string;
  };
  template: string;
  localeInfo: LocaleInfo;
};

export type LiquidConfig = {
  m2DRTVevents: boolean;
  states: string [];
  months: [];
  hostedFieldStyle?: {
    fonts?: any;
    elementStyles?: any;
    cardNumberPlaceholder?: string;
    cardCvcPlaceholder?: string;
    cardExpiryPlaceholder?: string;
  };
  showActivationNag: boolean;
  showMinimizedNag: boolean;
  timeItervalToDelayOpeningOfVisitorNag: number;
  productReviewAttributes: {
    authorAttributes: string[];
    reviewAttributes: string[];
  };
  collectionWithEditorialContent: CollectionWithEditorialContent;
  collectionWithShopifyBanner: boolean;
  collectionWithoutShopifyBanner: boolean;
  collectionWithShopifyFilesBanner: boolean;
  collectionPageInlineEditorialContent: boolean;
  collectionWithInlineEditorialContent: boolean;
  collectionWithCustomShopifyBanner: string[];
  eventForHomePageTTB: boolean;
  eventForClosetPageTTB: boolean;
  checkIpLocation: boolean;
}
export type config = LiquidConfig;
declare global {
  interface Window {
    _errs: CustomError;
    updateUserByUUIDandRedirect: Function;
    markUserTime: (option: string) => void;
    caastle: WindowCaastle;
    GBVirtualPageUrl: string;
    gb: {
      i18n: I18n;
      config: LiquidConfig;
      seasonalUtils: SeasonalUtils;
      userObjectInit: UserObjectInit;
      shopMetaFieldsBootstrapReleaseContent: any;
      liquid?: Liquid;
    };
    grecaptcha: {
      enterprise: { ready: Function; execute: Function };
      ready: Function;
      execute: Function;
    };
    isPageMigratedToReact: Function;
    pushLinkEvent: Function;
    testingDFPCarousel: string | boolean;
    testingDFPInline: boolean;
    requiredVersion: string;
    imgTestActive: boolean;
    google: {
      payments: {
        api: {
          PaymentsClient: ObjectConstructor;
        };
      };
    };
    enableABTestingOnAFA: boolean;
    showSimilarStyles: boolean;
    enableCAF2: boolean;
    gotAFATrue: boolean;
    RNFeedbackAB: boolean;
    enableAIFiltersABTest: boolean;
  }
}

export type GlobalState = {
  Backbone: Backbone;
  backboneListener: BackboneEvents;
  gb: Gb;
  gtm: Gtm;
  customer: Customer;
  bvAnalytics: BvAnalytics;
  liquid: Liquid;
  domUtils: DomUtils;
  seasonalUtils: SeasonalUtils;
  userObjectInit: UserObjectInit;
  shopMetaFieldsBootstrapReleaseContent: any;
  i18n: I18n;
  emitter: Emitter;
};

export type GlobalContextValue = {
  globalContext: GlobalState;
  setGlobalContext?: (data: GlobalState) => void;
};

export type NagStorageData = {
  showVisitorNagDFP: string;
  minimizedVisitorNagDFPCount: string;
  maximizedVisitorNagDFPCount: string;
  shownFromPage: string;
  shownFromPageValue: string;
};
export type AppDataList = AppData[];
export type AppData = {
  key: string;
  value: string;
};
export type Status = {
  code: number;
  message: string;
  sfUserMessage?: string;
}
export type EventInformation = {
  baseEventId: string;
  baseEventTs: string;
  baseEventType: string;
  sourceEventId: string;
};
export type Tenure = {
  days: number;
  months: number;
  sessionStartDate: string;
  sessionStatus: string;
  years: number;
};

export type ClosetSku = {
  available: boolean;
  color: string;
  position: number;
  size: string;
  sku: string;
  style: string;
  variantColor: string;
  variantSize: string;
  variantStyle: string;
};

export type Feedback = {
  'rating_id': number;
};

export type FitFeedback = {
  arms: number;
  hips: number;
  waist: number;
  bust: number;
}
export type SubscriptionThankyouHeadingProps = {
  closetMinimumReachedFlag: boolean;
};

export type SubscriptionThankyouMessageProps = {
  planSize: number;
  recommendedClosetSize: number;
  closetCountRequired: number;
  closetMinimumReachedFlag: boolean;
};

export type Button = {
  className: string;
  handle: string;
  icon: string;
  id: string;
  title: string;
  disabled?: boolean;
};

export type ButtonProps = {
  collectionLinks: Button[];
  disabled?: boolean;
};

export type RecommendedClosetSizeResponse = {
status?: number;
recommendedClosetSize?: number;
invalidResponse?: boolean;
};
export type RecommendedSizeOptions = {
  onError: (err: unknown) => void;
  onSuccess: (data: RecommendedClosetSizeResponse) => void;
  enabled: boolean;
};
export const defaultRecommendedSize: RecommendedClosetSizeResponse = {
  recommendedClosetSize: 20
};
export type CountResponse = {
  atHome: number;
  onRack: number;
  onHold: number;
  history: number;
  removed: number;
}
export type ClosetSummaryValueResponse = {
  count: CountResponse;
  isUserAboveClosetMin: boolean;
  closetMinThreshold: number;
};
export type ClosetSummaryResponse = {
  response?: ClosetSummaryValueResponse;
  invalidResponse?: boolean;
};
export type ClosetSummaryOptions = {
onSuccess: (data: ClosetSummaryResponse) => void;
onError: (err: unknown) => void;
enabled: boolean;
sourceEventId?: string;
clusterValue?: string;
};
export const defaultCountResponse: CountResponse = {
  atHome: 0,
  onRack: 0,
  onHold: 0,
  history: 0,
  removed: 0
};
export const defaultSummaryValueResponse: ClosetSummaryValueResponse = {
  count: defaultCountResponse,
  isUserAboveClosetMin: false,
  closetMinThreshold: 8
};
export const defaultSummaryResponse: ClosetSummaryResponse = {
  response: defaultSummaryValueResponse
};

export type PlanInfoResponse = {
  status?: number;
  numItems?: number;
  addOns?: AddOn[];
  invalidResponse?: boolean;
};
export type AddOn = {
  id: number;
  planId: number;
  name: string;
  numItems: number;
  addOnStartDate: string;
  addOnEndDate: string;
  createdAt: string;
  updatedAt: string;
};
export type PlanInfoOptions = {
  onError: (err: unknown) => void;
  onSuccess: (data: PlanInfoResponse) => void;
  enabled: boolean;
  sourceEventId: string;
  clusterValue: string;
};
export const defaultPlanResponse: PlanInfoResponse = {
  numItems: 0,
  addOns: []
};
export type CommonState = {
  isCoachingBarUpdated: boolean;
  onRackCount: number;
  isUpdatedFromCloset: boolean;
  isClosetLoading: boolean;
};
export type CommonContextValue = {
  commonContext: CommonState;
  setCommonContext: (data: CommonState) => void;
};
export type PlanAndClosetInfoResponse = {
  planInfo: PlanInfoResponse;
  closetSummaryInfo: ClosetSummaryResponse;
  recommendedClosetSizeInfo: RecommendedClosetSizeResponse;
};
export type PlanAndClosetInfoOptions = {
  sourceEventId: string;
  clusterValue: string;
  onSuccess: (planAndClosetData: any) => void;
  onError: (err: unknown) => void;
  enabled: boolean;
};
export type closetMinValueResponse = {
  uuid: string;
  planGarments: number;
  addOnGarments: number;
  openSlots: number;
  currentClosetSize: number;
  closetMinimumSize: number;
};
export type ClosetMinResponse = {
  status: Status;
  closetMinResponse: closetMinValueResponse;
  invalidResponse?: boolean;
};
export type ClosetMinOptions = {
  isSubscriber: boolean;
  onSuccess: (data: ClosetMinResponse) => void;
  onError: (err: unknown) => void;
  enabled: boolean;
};

export enum QuickClosetSourceStates {
  DBC = 'dbc',
  COLLECTION_QC = 'collectionQC'
};

export type DeliveryTimeResponse = {
  shipmentTime: number;
  invalidResponse?: boolean;
};

export type DeliveryTimeResponseOptions = {
  enabled: boolean;
  onSuccess: (data: DeliveryTimeResponse) => void;
  onError: (error: Error) => void;
};